"use client";

import React from "react";

import { CountrySelectorChildrenProps } from "~/bff/components/CountrySelectorChildren";
import { CountryCode } from "~/helpers/country/types";

import { NavItems } from "../../types";

import { GroupedLinksColumn } from "./components/grouped-links-column/component";
import { GroupedLinksColumnMobile } from "./components/grouped-links-column-mobile/component";
import { GroupedLinksContainerDesktop, GroupedLinksContainerMobile } from "./styled";

interface GroupedLinksProps {
  setSelectedCountry: (
    countryCode?: CountryCode,
    countryLanguageCode?: string,
  ) => void;
  selectedCountry?: CountryCode;
  selectedLanguage?: string;
  countries?: (CountrySelectorChildrenProps | undefined)[];
  groupedLinks: NavItems;
  title?: string;
  description?: string;
  shouldOpenAllLinksInNewTab?: boolean;
}

export const GroupedLinks: React.FC<GroupedLinksProps> = ({
  groupedLinks,
  selectedCountry,
  setSelectedCountry,
  countries,
  title,
  description,
  shouldOpenAllLinksInNewTab,
  selectedLanguage,
}) => {
  return (
    <>
      <GroupedLinksContainerMobile item xs={12} id="footer-mobile-grouped-links">
        {groupedLinks?.map((category, index) => (
          <GroupedLinksColumnMobile
            key={index}
            headline={category.headline}
            links={category.links}
            shouldOpenAllLinksInNewTab={shouldOpenAllLinksInNewTab}
          />
        ))}
      </GroupedLinksContainerMobile>
      <GroupedLinksContainerDesktop item lg={12} id="footer-grouped-links">
        {groupedLinks?.map((category, index) => (
          <GroupedLinksColumn
            key={index}
            headline={category.headline}
            links={category.links}
            selectedCountry={selectedCountry}
            selectedLanguage={selectedLanguage}
            setSelectedCountry={setSelectedCountry}
            showCountrySelector={index === 0}
            countries={countries}
            title={title}
            description={description}
            shouldOpenAllLinksInNewTab={shouldOpenAllLinksInNewTab}
          />
        ))}
      </GroupedLinksContainerDesktop>
    </>
  );
};
